<ng-container *ngIf="activeStep === stepIndex">
    <div class="form-group">
        <div class="auth">
            <ng-container *ngFor="let product of products index as i">
                <ng-container *ngIf="!product.hidden">
                    <div *ngIf="product['product_type'] !== lastProductType" class="end-border"></div>
                    <h3 *ngIf="product['product_type'] !== lastProductType">{{ 'billing_' + product['product_type'] | myLbTranslate }}</h3>
                    <div class="content-space-between">
                        <p class="service-name">{{ product.name }}</p>
                        <ng-container *ngFor="let price of product.prices">
                            <div class="radio-wrapper">
                                <input
                                    type="radio"
                                    id="{{price.interval}}"
                                    tabindex="0"
                                    name="{{price.id}}"
                                    [disabled]="(cartInterval && price.interval !== cartInterval)"
                                    [checked]="selectedPriceId[i] === price.id"
                                    appHint
                                    [hintText]="price.interval !== cartInterval
                                        ? ('checkout_interval_hint_test' | myLbTranslate) : ''"
                                    [hintShow]="!!(cartInterval && price.interval !== cartInterval)"
                                    (click)="setSelectedInterval(price.id, i)">
                                <label for="{{price.interval}}">
                                    {{ price.interval | myLbTranslate | titlecase }} {{ formatPrice(price) }}
                                </label>
                            </div>
                        </ng-container>
                        <!-- Fix alignment issues if no annual price -->
                        <ng-container *ngIf="product.prices.length === 1">
                            <div class="radio-wrapper"></div>
                        </ng-container>
                        <button
                            id="select-product_add-to-cart"
                            class="image-button"
                            [disabled]="product['product_type'] === 'portal' && cartHasPortalSubscription || cartMaxItemsReached"
                            appHint
                            [hintText]="product['product_type'] === 'portal' && cartHasPortalSubscription
                                ? ('checkout_cart_add_hint_test' | myLbTranslate) : ''"
                            (click)="addProductToCart(product, i)">
                            <img ngSrc="assets/centralisedManagement/icons/add-to-cart.svg" height="23" width="24"
                                 alt="Add to cart"/>
                        </button>
                    </div>
                    {{ setLastProductType(product['product_type']) }}
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="activeStep >= stepIndex">
    <h2 *ngIf="activeStep === stepIndex">{{ 'checkout_cart' | myLbTranslate }}</h2>
    <div class="set-content">
        <ng-container *ngIf="!cartItems.length">
            <p class="note">{{ 'checkout_cart_empty_message' | myLbTranslate }}</p>
        </ng-container>
        <ng-container *ngFor="let selectedProduct of cartItems index as i">
            <div class="content-space-between">
                <div class="product-title">
                    <strong>{{ 'product' | myLbTranslate }}:</strong>
                    {{ selectedProduct?.product?.name }}
                    <span>{{ formatPrice(selectedProduct?.price) }}</span>
                    <span class="note">
                        ({{ 'per_' + selectedProduct?.price?.interval | myLbTranslate }})
                    </span>
                </div>
                <div class="input-button-wrapper">
                    <input type="text" value="{{ selectedProduct.quantity }}" disabled/>
                    <button
                        id="select-product_delete-from-cart"
                        class="image-button"
                        [disabled]="activeStep > stepIndex"
                        (click)="deleteCartItem(selectedProduct)">
                        <img
                            ngSrc="assets/centralisedManagement/icons/bin.svg"
                            height="24"
                            width="21"
                            alt="bin icon delete item from cart"/>
                    </button>
                </div>
            </div>
        </ng-container>
        <app-notifications-banner
            *ngIf="cartMaxItemsReached && activeStep === stepIndex"
            [notification]="notification"
            [hideButtons]="true">
        </app-notifications-banner>
        <span *ngIf="activeStep > stepIndex">
            <button id="select-product_edit-step" class="button-as-link quinary right-arrow" (click)="setStep()">
                {{ 'edit' | myLbTranslate }}
            </button>
        </span>
    </div>
</ng-container>
